import { apiService } from '@/services/api.service';
import { isCanonicalPlayerUuid, isSamePlayerUuid } from '@/utils/playerUuid';

/**
 * Uuid de la fiche d'un joueur déjà identifié par son uuid (joueurs en ligne) : cet uuid quand il est
 * canonique (satellite v1.0.13 et plus : clé du keep-alive, celle de la ProfileApi), sans recherche.
 * Sinon (uuid aux octets inversés d'un satellite plus ancien), celui trouvé par le gamertag, pris
 * seulement s'il désigne le même joueur : la recherche passe d'abord par les pseudos Recube, et un
 * gamertag peut être le pseudo Recube d'un autre joueur.
 */
export async function sheetUuidOf(player: { uuid: string; name: string }): Promise<string> {
  if (isCanonicalPlayerUuid(player.uuid)) return player.uuid;
  const result = await apiService.searchPlayer(player.name);
  const found = result.data?.uuid;
  return found && isSamePlayerUuid(found, player.uuid) ? found : player.uuid;
}
